import {engineContext} from './context.js';

(function(global){'use strict';
const VERSION='0.1.0-alpha';
function norm(x){
  x=x||{};
  return Object.freeze({
    symbol:x.symbol||null,
    scope:['OWNED','WATCHLIST','RESEARCH'].includes(x.scope)?x.scope:'RESEARCH',
    deltaState:x.deltaState||'UNCHANGED',
    readinessBefore:x.readinessBefore||'UNKNOWN',
    readinessAfter:x.readinessAfter||'UNKNOWN',
    thesisDrift:x.thesisDrift||'STABLE',
    compoundState:x.compoundState||'NO_COMPOUND_SIGNAL',
    invalidatedCount:Number.isFinite(x.invalidatedCount)?Math.max(0,Math.floor(x.invalidatedCount)):0,
    newGapCount:Number.isFinite(x.newGapCount)?Math.max(0,Math.floor(x.newGapCount)):0,
    eventWithin24h:x.eventWithin24h===true,
    evidenceChanged:x.evidenceChanged===true,
    nextTask:x.nextTask||null
  });
}
function rank(x){
  const n=norm(x); let p=0;
  if(n.scope==='OWNED') p+=30; else if(n.scope==='WATCHLIST') p+=10;
  if(n.deltaState==='ESCALATED') p+=30; else if(n.deltaState==='CHANGED') p+=12; else if(n.deltaState==='DE_ESCALATED') p+=8;
  if(n.readinessAfter==='BLOCKED'&&n.readinessBefore!=='BLOCKED') p+=35;
  else if(n.readinessAfter==='BLOCKED') p+=20;
  else if(n.readinessAfter==='REVIEW'&&n.readinessBefore==='READY_FOR_DECISION') p+=18;
  if(n.thesisDrift==='MATERIAL_DRIFT') p+=30; else if(n.thesisDrift==='REVIEW_DRIFT') p+=15;
  if(n.compoundState==='COMPOUND_NEGATIVE') p+=25; else if(n.compoundState==='COMPOUND_MIXED') p+=18; else if(n.compoundState==='BUILDING_NEGATIVE') p+=12;
  p+=Math.min(20,n.invalidatedCount*7);
  p+=Math.min(15,n.newGapCount*4);
  if(n.eventWithin24h) p+=12;
  if(n.evidenceChanged) p+=8;
  return p;
}
function reason(x){
  const n=norm(x),r=[];
  if(n.readinessAfter==='BLOCKED'&&n.readinessBefore!=='BLOCKED') r.push('decision readiness newly blocked');
  if(n.deltaState==='ESCALATED') r.push('compound evidence escalated');
  if(n.thesisDrift==='MATERIAL_DRIFT') r.push('material thesis drift');
  if(n.invalidatedCount) r.push(`${n.invalidatedCount} conclusion(s) invalidated/reopened`);
  if(n.newGapCount) r.push(`${n.newGapCount} new evidence gap(s)`);
  if(n.compoundState==='COMPOUND_NEGATIVE') r.push('negative multi-domain evidence confirmed');
  if(n.eventWithin24h) r.push('relevant event within 24h');
  if(!r.length&&n.evidenceChanged) r.push('evidence changed');
  return Object.freeze(r.slice(0,4));
}
function prioritize(items,limit){
  const rows=(Array.isArray(items)?items:[]).map(norm).map(x=>Object.freeze({...x,priority:rank(x),reasons:reason(x)}));
  rows.sort((a,b)=>b.priority-a.priority||(a.symbol||'').localeCompare(b.symbol||''));
  return Object.freeze(rows.slice(0,Number.isFinite(limit)?Math.max(1,Math.floor(limit)):10));
}
function selfTest(){
  const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});
  const base={symbol:'AAA',scope:'OWNED',deltaState:'UNCHANGED',readinessBefore:'REVIEW',readinessAfter:'REVIEW',thesisDrift:'STABLE',compoundState:'NO_COMPOUND_SIGNAL'};
  ok('owned scope raises priority',rank(base)>rank({...base,scope:'RESEARCH'}));
  ok('escalated delta raises priority',rank({...base,deltaState:'ESCALATED'})>rank(base));
  ok('newly blocked readiness raises priority',rank({...base,readinessBefore:'REVIEW',readinessAfter:'BLOCKED'})>rank({...base,readinessBefore:'BLOCKED',readinessAfter:'BLOCKED'}));
  ok('material thesis drift raises priority',rank({...base,thesisDrift:'MATERIAL_DRIFT'})>rank(base));
  ok('compound negative raises priority',rank({...base,compoundState:'COMPOUND_NEGATIVE'})>rank(base));
  ok('invalidations raise priority',rank({...base,invalidatedCount:2})>rank(base));
  ok('new gaps raise priority',rank({...base,newGapCount:2})>rank(base));
  ok('near event raises priority',rank({...base,eventWithin24h:true})>rank(base));
  ok('evidence change raises priority',rank({...base,evidenceChanged:true})>rank(base));
  const hot={...base,symbol:'HOT',deltaState:'ESCALATED',readinessAfter:'BLOCKED',thesisDrift:'MATERIAL_DRIFT'};
  const cool={...base,symbol:'COOL',scope:'WATCHLIST'};
  ok('prioritize sorts hottest first',prioritize([cool,hot],10)[0].symbol==='HOT');
  ok('limit respected',prioritize([cool,hot],1).length===1);
  ok('reason identifies newly blocked state',reason(hot).some(x=>x.includes('blocked')));
  ok('reason identifies thesis drift',reason(hot).some(x=>x.includes('thesis')));
  ok('unchanged stable case can have no reasons',reason(base).length===0);
  return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}
const API={VERSION,norm,rank,reason,prioritize,selfTest};
try{API.selfTestResult=selfTest()}catch(e){API.bootstrapError=String(e&&e.stack||e)}
global.ZooInvestDecisionChangePriorityEngine=Object.freeze(API);
})(engineContext);